
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent} from 'vue';
import {getLocaleDayOfMonthOfISO, getLocaleDayNameOfISO, getLocaleMonthNameOfISO, getLocaleYearOfISO} from "../../utils/utils";

export default defineComponent({
    name: "CalendarSelection",
    props: {
        label: {
            type: String,
            required: true,
        },
        ISODate: {
            type: String,
            required: true,
        },
    },
    setup(props, {emit}) {
        return {
            translate,
            getLocaleDayOfMonthOfISO,
            getLocaleDayNameOfISO,
            getLocaleMonthNameOfISO,
            getLocaleYearOfISO,
        }
    }
});
